import { WhatsappBroadcastsService } from './../../service/whatsapp-broadcasts.service';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { AuthStateService } from 'src/app/shared/auth-state.service';
import { SharedComponentsModule } from 'src/app/shared/shared-components/shared-components.module';
import { MultiSelectModule } from 'primeng/multiselect';
import { CustomerService } from '../../service/customer.service';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-whatsapp-broadcasts',
    standalone: true,
    imports: [
        CommonModule,
        CardModule,
        ToastModule,
        DialogModule,
        FormsModule,
        MultiSelectModule,
        InputTextModule,
        DropdownModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        ButtonModule,
    ],
    templateUrl: './whatsapp-broadcasts.component.html',
    styleUrl: './whatsapp-broadcasts.component.scss',
    providers: [MessageService],
})
export class WhatsappBroadcastsComponent {
    visible: boolean = false;
    loadingMessage!: String;
    screenWidth: number = 1200;

    templates: any[] = [];
    templateMessage!: any;
    selectedTemplateId!: number;
    customers: any[] = [];

    templatesForm!: FormGroup;
    createTemplateForm!: FormGroup;

    constructor(
        private fb: FormBuilder,
        private customerService: CustomerService,
        private whatsappBroadcastApi: WhatsappBroadcastsService,
        private authStateService: AuthStateService,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.fetchTemplates();
        this.screenWidth = window.innerWidth;
        window.addEventListener('resize', this.onResize.bind(this));
        this.initializeTemplateForm();
        this.initializeCreateTemplateForm();
    }

    createTemplate() {
        this.whatsappBroadcastApi
            .createTemplate({
                "name": this.createTemplateForm.get('name')?.value,
            })
            .subscribe({
                next: (response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Template created successfully',
                    });
                    this.createTemplateForm.reset();
                    this.fetchTemplates();
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.message,
                    });
                },
            });
    }

    initializeTemplateForm() {
        this.templatesForm = this.fb.group({
            template: [null, [Validators.required]],
        });
    }

    initializeCreateTemplateForm() {
        this.createTemplateForm = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(2)]],
        });
    }

    fetchTemplates() {
        this.whatsappBroadcastApi.fetchTemplates().subscribe({
            next: (response) => {
                this.templates = response['messageTemplates'].map(
                    (template: any) => ({
                        label: template.name,
                        value: template.id,
                    })
                );
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.error.message,
                });
            },
        });
    }

    onTemplateChange(event: DropdownChangeEvent) {
        this.loadingMessage = 'Loading template messages...';
        this.selectedTemplateId = event.value;
        this.visible = true;
        this.whatsappBroadcastApi.fetchTemplateById(event.value).subscribe({
            next: (response) => {
                this.templateMessage = response['messageTemplate'];
                this.visible = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Template messages fetched successfully',
                });
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch template messages',
                });
                this.visible = false;
            },
        });
    }



    submitBroadcastMessages() {
        this.loadingMessage = 'Sending broadcast messages...';
        this.visible = true;
        this.whatsappBroadcastApi
            .sendBroadcastMessage(this.fetchPayload())
            .subscribe({
                next: (value) => {
                    this.visible = false;
                    this.templatesForm.reset();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Broadcast messages sent successfully',
                    });
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: err.error.message,
                    });
                    this.visible = false;
                },
            });
    }

    fetchPayload(): any {
        return {
            messageTemplateId: this.selectedTemplateId,
        };
    }

    onResize(event: Event) {
        this.screenWidth = window.innerWidth;
    }

    showDialog() {
        this.visible = true;
    }

    closeDialog() {
        this.visible = false;
    }

    hasPermission(permission): boolean {
        return this.authStateService.checkUserPermission(permission);
    }
}
